import React from "react";
import AgentBioListings from "@/components/AgentBioListings";
import AgentTrackRecord from "@/components/AgentTrackRecord";
import AgentBioMarkets from "@/components/AgentBioMarkets";
import { AgentBioLinks, AgentBioTestimonials } from "@/components/AgentBioAbout";
import { BIO_SECTIONS, resolveLayout } from "@/helpers/bioLayout";

const AgentBioSections = ({ agent, layout, onOpen, onTrack, showMissingLinks = false }) => {
  if (!agent) return null;
  const { order } = resolveLayout(layout);
  const proKeys = new Set(BIO_SECTIONS.filter((section) => section.pro).map((section) => section.key));
  const sections = {
    buyers: (
      <AgentBioListings
        firstName={agent.FirstName}
        wantAds={agent.activeWantAds}
        total={agent.activeWantAdCount}
        onOpen={onOpen}
      />
    ),
    history: <AgentTrackRecord history={agent.history} agent={agent} onOpen={onOpen} />,
    markets: <AgentBioMarkets agent={agent} />,
    links: <AgentBioLinks agent={agent} showMissing={showMissingLinks} onTrack={onTrack} />,
    testimonials: <AgentBioTestimonials agent={agent} />,
  };
  return order
    .filter((key) => agent.isPremiumAgent || !proKeys.has(key))
    .map((key) => <React.Fragment key={key}>{sections[key]}</React.Fragment>);
};

export default AgentBioSections;
